module.exports = "/static/assets/7b97c5bb59e0139602708986bd21cfeb.gif";